<template>
  <BaseMap id="sharing-recent-ancestry" v-if="showMap" @map-loaded="mapLoaded" />
</template>

<script setup>
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useSharingStore } from "@/store/sharing";
import { useAutosomalStore } from "@/store/ancestry/autosomal";
import { calculateOpacity, MapLayer, useMap } from "@/view/ancestry/recent/mapHelpers";
//import BaseMap from "@/components/BaseMap.vue";
import BaseMap from "@/components/Maps/BaseMap.vue";

/* const props = defineProps({
  autosomalResult: Object,
}); */

const router = useRouter();
const route = useRoute();
const sharingStore = useSharingStore();
const autosomalStore = useAutosomalStore();

const showMap = ref(false);

setTimeout(() => {
  showMap.value = true;
}, 500);

let unwatch;

// Match useMap()'s source-layer lookups (which use the autosomal store's tileset) so the
// source url and feature queries stay consistent for the current profile's panel.
const tileset = autosomalStore.tileset;

const mapSource = {
  id: tileset,
  type: "vector",
  url: `mapbox://${tileset}`,
};

async function mapLoaded(map) {
  const { boundingBoxMove, createActiveLayer, getFeatures } = useMap(map);

  map.addSource("tests", {
      type: "vector",
      url: mapSource.url,
  });

  sharingStore.mapItems.forEach((mapElement) => {
      const layer = new MapLayer(
          mapElement.id,
          mapElement.properties.colour,
          mapElement.properties.code,
          false,
          calculateOpacity(
              typeof mapElement.properties.percentage !== "number"
                  ? 100
                  : mapElement.properties.percentage
          ),
          tileset
      );
      map.addLayer(layer);

      map.on("click", mapElement.id, ({ features }) => {
          const [feature] = features;

          router.push({
              name: "recent-ancestry-detail",
              params: {
                  groupId: feature.layer.id,
              },
          });
      });
  });

  setTimeout(() => {
      const allFeatures = getFeatures();
      unwatch = watch(
          () => route.params.groupId,
          (groupId) => {
              if (groupId) {
                  createActiveLayer(groupId);
              } else {
                  boundingBoxMove(allFeatures, 100);
              }
          },
          {
              immediate: true,
          }
      );
  }, 500);
}
console.log(unwatch);
</script>
